import { useNavigate } from 'react-router-dom';
import { RestaurantCard } from '@molecules/index';
import { Icon, Button } from '@atoms/index';
import type { Restaurant } from '@/types';

interface RestaurantGridProps {
  restaurants: Restaurant[];
  isLoading?: boolean;
  onChangeLocation?: () => void;
  onViewAllRestaurants?: () => void;
}

const RestaurantGrid = ({
  restaurants,
  isLoading = false,
  onChangeLocation,
  onViewAllRestaurants,
}: RestaurantGridProps) => {
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="h-72 bg-gray-200 rounded-lg animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (restaurants.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-6 animate-fade-in">
        <div className="inline-flex p-6 rounded-3xl bg-primary/5 mb-6">
          <Icon name="store" size={72} className="text-primary" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">
          Bu bölgede henüz restoran yok
        </h3>
        <p className="text-gray-600 text-center max-w-md mb-8 leading-relaxed">
          Farklı bir konum seçerek yakınındaki lezzetleri keşfedebilirsin.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-sm">
          {onChangeLocation && (
            <Button
              variant="primary"
              size="lg"
              onClick={onChangeLocation}
              className="w-full sm:flex-1 shadow-premium"
            >
              <Icon name="location" size={20} className="mr-2" />
              Konumu Değiştir
            </Button>
          )}
          {onViewAllRestaurants && (
            <Button
              variant="outline"
              size="lg"
              onClick={onViewAllRestaurants}
              className="w-full sm:flex-1"
            >
              <Icon name="store" size={20} className="mr-2" />
              Tüm Restoranları Gör
            </Button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {restaurants.map((restaurant) => (
        <RestaurantCard
          key={restaurant.id}
          restaurant={restaurant}
          onClick={() => navigate(`/restaurant/${restaurant.id}`)}
        />
      ))}
    </div>
  );
};

export default RestaurantGrid;
